import { useRef, useEffect, useState } from "react";
import axios from "axios";
import "./profileEdit.css";
import { test_ip } from "../../services/constants";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { setError } from "../../services/actions";
import { useDispatch } from "react-redux";

const ProfileEditPage = (props) => {
  const [user, setUser] = useState();
  const [changePass, setChangePass] = useState(false);
  const [change, setChange] = useState(false);
  const first_name = useRef();
  const [editPro, setEditPro] = useState(true);
  const last_name = useRef();
  const email = useRef();
  const address = useRef();
  const password = useRef();
  const old_password = useRef();
  const new_password = useRef();
  const confirm_password = useRef();
  const diapach = useDispatch();

  const editProfile = (e) => {
    e.preventDefault();
    console.log(first_name.current.value);
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      first_name: first_name.current.value
        ? first_name.current.value
        : first_name.current.placeholder,
      last_name: last_name.current.value
        ? last_name.current.value
        : last_name.current.placeholder,
      email: email.current.value
        ? email.current.value
        : email.current.placeholder,
      address: address.current.value
        ? email.current.value
        : address.current.placeholder,
      old_password: password.current.value ? password.current.value : " ",
      new_password: password.current.value ? password.current.value : " ",
    };
    console.log(data);
    Update_User_data(data);
  };

  const changePassword = (e) => {
    e.preventDefault();
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
      first_name: first_name.current.value
        ? first_name.current.value
        : first_name.current.placeholder,
      last_name: last_name.current.value
        ? last_name.current.value
        : last_name.current.placeholder,
      email: email.current.value
        ? email.current.value
        : email.current.placeholder,
      address: address.current.value
        ? email.current.value
        : address.current.placeholder,
      old_password: old_password.current.value
        ? old_password.current.value
        : " ",
      new_password: new_password.current.value
        ? new_password.current.value
        : " ",
    };
    if (new_password.current.value == confirm_password.current.value) {
      console.log("password match");
      Update_User_data(data);
      console.log("password match23243");
    } else {
      alert("New paswword doesn't much");
    }
  };

  const Update_User_data = function (data) {
    // update user data page
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/update`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // you would get something like this
            //user_data = res.data.user // with full user data
            console.log(res.data.user);
            alert("Updated Successfully");
            window.location.reload(false);
          } else {
            console.log("erororor", res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
            if (res.data.error_code === 513) alert("Invalid Password");
          }
        } else {
          // do something
          diapach(setError({ error: true, message: "failed,please reload" }));
        }
      })
      .catch((err) => {
        // do something
      });
  };

  return (
    <div className="b-profile-edit-page">
      {props.edit ? (
        <div className="b-main">
          {editPro ? (
            <div className="b-popup">
              <div>
                <button
                  style={{
                    float: "right",
                  }}
                  onClick={() => props.setEdit(false)}
                >
                  <FaTimes fill="#f12235" size="20px" />
                </button>
              </div>
              <div>
                <form>
                  <label>First Name:</label>
                  <input
                    type="text"
                    ref={first_name}
                    placeholder={props.users.first_name}
                  />
                  <br />
                  <label>Last Name:</label>
                  <input
                    type="text"
                    ref={last_name}
                    placeholder={props.users.last_name}
                  />
                  <br />
                  <label>Email:</label>
                  <input
                    type="text"
                    ref={email}
                    placeholder={props.users.email}
                  />
                  <br />
                  <label>address:</label>
                  <input type="text" ref={address} />
                  <br />

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setChange(true);
                    }}
                  >
                    Update
                  </button>
                  <div className={change ? "page page-active" : "page"}>
                    <label>Enter Password</label>
                    <input type="password" ref={password} />
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        editProfile(e);
                      }}
                    >
                      Submit
                    </button>
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setChangePass(true);
                      setEditPro(false);
                    }}
                    className="b-btn-change-pass"
                  >
                    Change Password
                  </button>
                </form>
              </div>
            </div>
          ) : (
            ""
          )}
          {changePass ? (
            <div className={changePass ? "page page-active" : "page"}>
              <div className="b-popup">
                <form>
                  <label>Old Password:</label>
                  <input type="password" ref={old_password} />
                  <br />
                  <label>New Password:</label>
                  <input type="password" ref={new_password} />
                  <br />
                  <label>Confirm Password</label>
                  <input type="password" ref={confirm_password} />
                  <button
                    onClick={(e) => {
                      changePassword(e);
                    }}
                  >
                    Submit
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setChangePass(false);
                      props.setEdit(false);
                    }}
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ProfileEditPage;
